module.exports = __webpack_public_path__ + "img/pms2.3184a52c.jpg";